import { Settings } from "lucide-react";
import MenuIconTooltip from "./MenuIconTooltip";
import { MENU_TRAINING_TOOLTIPS } from "../constants/menuTooltips";

export default function TrainingSessionNav({ visible = false, onConfigClick = () => {} }) {
  if (!visible) return null;

  return (
    <div className="menuFilterContainer training-session-nav">
      <MenuIconTooltip
        tooltip={MENU_TRAINING_TOOLTIPS.config}
        placement="left"
        portal
        className="filterIcon filterIcon--enabled"
      >
        <Settings
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={onConfigClick}
          aria-label="Retour à la configuration de l'entraînement"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>
    </div>
  );
}
